import { CompassCardUI } from '@scale/compass-ui/types';
import {
  PassAtKCardShared,
  type PassAtKSchemaType,
  type PassAtKContext,
  PASS_AT_K,
} from '@scale/genai-compass-shared/cards/pass_at_k';
import PassAtKCardComponent from './PassAtKCardComponent';

const defaultContext: PassAtKContext = {
  cardType: PASS_AT_K,
  runId: '',
};

export const PassAtKCardInfo: CompassCardUI<PassAtKSchemaType> = {
  ...PassAtKCardShared,
  title: 'Pass@K',
  icon: 'robot',
  toolTip: 'Pass@K Run Information',
  defaultContext,
  legacyComponent: PassAtKCardComponent,
};
